import argumentDataSources from '@/schema/argumentDataSources';
import appActions from '@/screens/apps/redux/actions/appActions';
import stepActions from '@/screens/workflows/redux/actions/stepActions';
import ArgumentRawObjectButton from './ArgumentRawObjectButton';

const ArgumentInputObject = ({ disabled, argument, dataSource, dataSourcePath, dataSavePath, index }) => {
  const stepDataSources = [argumentDataSources.workflowStep, argumentDataSources.workflowVariables, `${argumentDataSources.workflowStep}-customArguments`];
  const actions = stepDataSources.includes(dataSource) ? stepActions : appActions;

  if (disabled) {
    return null;
  }

  return (
    <div className="row-item-options">
      <ArgumentRawObjectButton actions={actions} argument={argument} dataSource={dataSource} dataSourcePath={dataSourcePath} dataSavePath={dataSavePath} />
    </div>
  );
};

export default ArgumentInputObject;
